var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevilages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2727 10.9091C12.36 10.9091 6.54545 12.36 6.54545 15.2727V17.4545H24V15.2727C24 12.36 18.1855 10.9091 15.2727 10.9091ZM15.2727 8.72727C16.43 8.72727 17.5399 8.26753 18.3583 7.44919C19.1766 6.63085 19.6364 5.52094 19.6364 4.36364C19.6364 3.20633 19.1766 2.09642 18.3583 1.27808C17.5399 0.459739 16.43 0 15.2727 0C14.1154 0 13.0055 0.459739 12.1872 1.27808C11.3688 2.09642 10.9091 3.20633 10.9091 4.36364C10.9091 5.52094 11.3688 6.63085 12.1872 7.44919C13.0055 8.26753 14.1154 8.72727 15.2727 8.72727ZM4.36364 10.1236L7.03636 11.7491L6.32727 8.68364L8.72727 6.63273L5.57455 6.36L4.36364 3.48L3.13091 6.36L0 6.63273L2.37818 8.68364L1.63636 11.7491L4.36364 10.1236Z",
    fill: "#5C5D6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevilages);
export default __webpack_public_path__ + "static/media/previlages.511a93f911233b538881e264d1e6cfb7.svg";
export { ForwardRef as ReactComponent };